export default "/images/vendor/flag-icon-css/flags/4x3/do.svg?c05850db8e87e53a12689a7c273cc1c7";